import { EntriFlowStatus } from '@wix/domains-serverless-interface';
export const buildMobileEntriDivertStatus = _ref => {
  let {
    divert,
    StatusComponent
  } = _ref;
  return handlers => _ref2 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      actionHandler
    } = _ref2;
    return {
      action: async () => {
        if (!msid || !siteName) {
          await (actionHandler == null ? void 0 : actionHandler({
            result: EntriFlowStatus.manual,
            domainName,
            externalViewer,
            msid,
            siteName
          }));
          return;
        }
        await divert({
          domainName,
          metaSiteId: msid,
          siteName
        }, handlers);
      },
      StatusComponent
    };
  };
};
//# sourceMappingURL=mobileEntriDivertStatus.js.map